<template>
  <vx-card>
    <ValidationObserver
      v-slot="{ handleSubmit }"
      ref="validationObserver"
    >
      <form @keydown.enter.prevent="() => { handleSubmit(onSubmit) }">
        <div class="vx-row pb-10">
          <div class="vx-col sm:w-1/2 w-full vx-row justify-start">
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <tm-input
                class="w-full"
                name="العنوان"
                placeholder="العنوان"
                type="text"
                validation-rules="required"
                v-model="task.title"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <label>من تاريخ</label>
              <datepicker
                class="w-full"
                name="من تاريخ"
                placeholder="من تاريخ"
                type="date"
                v-model="task.startAt"
                :validation-rules="isDateRequired ? 'required' : ''"
                format="yyyy-MM-dd"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <label>الى تاريخ</label>
              <datepicker
                class="w-full"
                name="إلى تاريخ"
                placeholder="إلى تاريخ"
                type="date"
                v-model="task.endAt"
                :validation-rules="isDateRequired ? 'required' : ''"
                format="yyyy-MM-dd"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <tm-select
                class="w-full"
                :options="volunteeringFields"
                label="name"
                validation-rules="required"
                name="نوع الفرصة"
                :reduce="(name) => name.id"
                v-model="task.volunteeringFieldId"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <tm-select
                class="w-full"
                :options="positiveCoupons"
                label="name"
                validation-rules="required"
                name="الكوبون الموجب"
                :reduce="(name) => name.code"
                v-model="task.couponCode"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <tm-select
                class="w-full"
                :options="negativeCoupons"
                label="name"
                validation-rules="required"
                name="الكوبون السالب"
                :reduce="(name) => name.code"
                v-model="task.deductCouponCode"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <tm-input
                class="w-full"
                name="المكان"
                placeholder="المكان"
                type="text"
                validation-rules="required"
                v-model="task.place"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <tm-select
                class="w-full"
                :options="getTaskTypesOptions"
                label="name"
                validation-rules="required"
                name="النوع"
                :reduce="(name) => name.value"
                v-model="task.type"
              />
            </div>
            
            <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
              <div>
                <p
                  class="mt-2 mb-2 px-2"
                  style="font-size: smaller"
                >
                  شرط التسجيل (مع او بدون شرط)
                </p>
                <!-- v-model="isLimited" -->
                <vs-switch
                  v-model="changeRegisterationCondation"
                  icon-pack="feather"
                  vs-icon="icon-check"
                />
              </div>
              <div v-if="changeRegisterationCondation">
                <tm-input
                  class="w-full"
                  name="تحديد عدد الجلسات "
                  placeholder="تحديد عدد الجلسات "
                  type="number"
                  v-model="task.maxSessionsPerVolunteer"
                />
                <tm-input
                  class="w-full"
                  name="تحدد عدد الأيام "
                  placeholder="تحديد عدد الايام "
                  type="number"
                  v-model="task.maxSessionDaysPerVolunteer"
                />
              </div>
            </div>


            <div class="vx-col sm:full w-full mb-2 mt-2">
              <p
                class="mt-2 mb-2 px-2"
                style="font-size: smaller"
              >
                يمكن إرفاق ملف؟
              </p>
              <vs-switch
                v-model="task.canUploadAttachment"
                icon-pack="feather"
                vs-icon="icon-check"
              />
            </div>
            <div class="vx-col w-full mb-2 mt-4">
              <p
                class="mt-2 px-2"
                style="font-size: smaller"
              >
                الوصف
              </p>
              <tm-text-area
                class="w-full"
                name="الوصف"
                validation-rules="required"
                v-model="task.description"
              />
            </div>
            <div class="vx-col w-full mb-2 mt-4">
              <p
                class="mt-2 px-2"
                style="font-size: smaller"
              >
                المواصفات
              </p>
              <tm-text-area
                class="w-full"
                name="المواصفات"
                validation-rules="required"
                v-model="task.specifications"
              />
            </div>
            <div class="vx-col w-full mb-2 mt-4">
              <p
                class="mt-2 px-2"
                style="font-size: smaller"
              >
                الخطوات
              </p>
              <tm-text-area
                class="w-full"
                name="الخطوات"
                v-model="task.steps"
              />
            </div>
            <div class="vx-col w-full">
              <p
                class="mt-2 px-2"
                style="font-size: smaller"
              >
                صورة
              </p>
              <file-pond-component
                :file="task.image"
                @fileDeleted="task.image = null"
                @fileUploaded="(file) => (task.image = file)"
                :upload-url="`${volunteerApiBaseUrl}v1/files/upload`"
                :rules="{ required: false }"
                project="volunteer"
              />
            </div>
          </div>
          <!-- divider horizontal -->
          <div style="width: 1px; height: 100vh; background-color: #e0e0e0;" />
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <h4
                v-if="sessions.length"
                class="mb-4"
              >
                الجلسات
              </h4>
              <div style="max-height: 400px; overflow-y: scroll;">
                <div
                  v-for="(session, index) in sortedSessions"
                  :key="index"
                  style="margin-bottom: 25px;"
                >
                  <vx-card>
                    <div class="vx-row justify-between px-4 py-2">
                      <div class="vx-col">
                        <p>
                          <span class="font-bold">
                            التاريخ
                          </span>: 
                          {{ 
                            session.date 
                              ? utilities.formatDate(session.date, "DD-MM-YYYY")
                              : 'لم يتم تحديده' 
                          }}
                        </p>
                        <p><span class="font-bold">وقت البدء</span>: {{ session.startAt || 'لم يتم تحديده' }}</p>
                        <p><span class="font-bold">وقت الانتهاء</span>: {{ session.endAt || 'لم يتم تحديده' }}</p>
                        <p><span class="font-bold">عدد المقاعد</span>: {{ session.maxSeats || 'لم يتم تحديده' }}</p>
                      </div>
                      <div class="flex flex-wrap items-center gap-2 mt-3">
                        <vs-button
                          type="filled"
                          color="danger"
                          style="height: 40px;"
                          v-if="task.status !== 'approved'"
                          @click.prevent="deleteSession(session)"
                        >
                          حذف الجلسة
                        </vs-button>
                        <!-- edit -->
                        <vs-button
                          type="filled"
                          color="primary"
                          style="height: 40px;"
                          @click.prevent="editSession(session)"
                        >
                          تعديل الجلسة
                        </vs-button>
                        <vs-button
                          type="filled"
                          color="success"
                          style="height: 40px;"
                          @click.prevent="openRepeatSession(session)"
                        >
                          تكرار الجلسة
                        </vs-button>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
            <div>
              <TaskSessionForm
                @addSession="onAddSession"
                :id="selectedSession.id || null"
                :date="selectedSession.date"
                :end-at="selectedSession.endAt"
                :start-at="selectedSession.startAt"
                :max-seats="selectedSession.maxSeats"
                :open-repeat-dialog="openRepeatDialog"
                @updateOpenRepeatDialog="openRepeatDialog = $event"
                :session-to-repeat="sessionToRepeat"
                :repeat-from-date="repeatFromDate"
                :repeat-to-date="repeatToDate"
                @addSessions="onAddRepeatedSessions"
                @clearSessionToRepeat="sessionToRepeat = $event"
                :is-edit="isEdit" 
                @update:isEdit="isEdit = $event"
              />
            </div>
          </div>
        </div>
        <div class="vx-row justify-center pt-10 mb-5">
          <vs-button
            type="filled"
            color="success"
            @click.prevent="handleSubmit(onSubmit)"
          >
            حفظ
          </vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>
</template>

<script>
import FilePondComponent from "@/app/shared/shared-components/FilePondComponent";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import TaskSessionForm from "../components/TaskSessionForm.vue";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import TmInput from "@/app/shared/shared-components/TmInput";
import { RepositoryFactory as LoyaltyRepositoryFactory } from "../../loyalty-system/loyalty-repositories/loyaltyRepositoryFactory";
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import { environment } from "@/environment";
import { Task, TaskDuplicate } from "../models";
import Datepicker from 'vuejs-datepicker';
import utilities from "@/app/shared/utilities/index";

const tasksRepo = RepositoryFactory.get("tasksRepository");
const couponsRepo = LoyaltyRepositoryFactory.get("couponsRepository");

export default {
  name: "AddTask",
  components: {
    TmInput,
    TmSelect,
    TmTextArea,
    TaskSessionForm,
    FilePondComponent,
    Datepicker,
  },
  data() {
    return {
      taskTypes: {
        normal: "عادي",
        urgent: "مستعجل",
      },
      task: Task(),
      sessions: [],
      coupons: [],
      selectedSession: {},
      selectedSessionIndex: null,
      volunteeringFields: [],
      volunteerApiBaseUrl: environment.volunteerApiBaseUrl,
      utilities,
      openRepeatDialog: false,
      sessionToRepeat: null,
      repeatFromDate: null,
      repeatToDate: null,
      isEdit:false,
    };
  },
  computed: {
    positiveCoupons() {
      return this.coupons.filter((coupon) => coupon.points >= 0);
    },
    negativeCoupons() {
      return this.coupons.filter((coupon) => coupon.points < 0);
    },
    isDateRequired() {
      return Boolean(this.task.startAt || this.task.endAt);
    },
    isDuplicate() {
      return Boolean(this.$route.meta && this.$route.meta.isDuplicate);
    },
    getTaskTypesOptions() {
      return Object.keys(this.taskTypes).map(key => ({
        name: this.taskTypes[key],
        value: key
      }));
    },
    sortedSessions() {
      return [...this.sessions].sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
    },
    changeRegisterationCondation: {
      get() {
        return (
          this.task.maxSessionsPerVolunteer !== null ||
          this.task.maxSessionDaysPerVolunteer !== null
        );
      },
      set(value) {
        if (!value) {
          this.task.maxSessionsPerVolunteer = null;
          this.task.maxSessionDaysPerVolunteer = null;
        } else {
          if (this.task.maxSessionsPerVolunteer === null) {
            this.task.maxSessionsPerVolunteer = "";
          }
          if (this.task.maxSessionDaysPerVolunteer === null) {
            this.task.maxSessionDaysPerVolunteer = "";
          }
        }
      }
    }
  },
  methods: {
    async getAllVolunteeringFields() {
      this.volunteeringFields = await tasksRepo.fetchVolunteeringFields();
    },
    async getAllCoupons() {
      const data = await couponsRepo.fetchCoupons(
        "?filter=app.name||$cont||المتطوعين"
      );
      this.coupons = data.data;
    },
    async onSubmit() {
      if (this.changeRegisterationCondation) {
        const sessionsVal = this.task.maxSessionsPerVolunteer;
        const daysVal = this.task.maxSessionDaysPerVolunteer;

        const isEmptySessions = sessionsVal === null || sessionsVal === "";
        const isEmptyDays = daysVal === null || daysVal === "";

        if (isEmptySessions && isEmptyDays) {
          return this.$vs.notify({
            title: 'خطأ',
            color: 'danger',
            text: ' احد الحقلين (عدد الجلسات أو عدد الأيام) مطلوب',
          });
        }
      }
      if (this.sessions.length === 0) {
        return this.$vs.notify({
          title: 'خطأ',
          color: 'danger',
          text: 'يجب إضافة جلسة واحدة على الأقل للفرصة التطوعية.',
        });
      }
      const task = {
        ...this.task,
        canUploadAttachment: Boolean(this.task.canUploadAttachment),
        couponPoints: this.coupons.find(
          (coupon) => coupon.code == this.task.couponCode || ""
        ).points,
        deductCouponPoints: this.coupons.find(
          (coupon) => coupon.code == this.task.deductCouponCode || ""
        ).points,
      };
      task.maxSessionsPerVolunteer = task.maxSessionsPerVolunteer !== null && this.task.maxSessionsPerVolunteer !== "" 
      ?  
        Number(task.maxSessionsPerVolunteer)
      : null;
      task.maxSessionDaysPerVolunteer = task.maxSessionDaysPerVolunteer !== null && this.task.maxSessionDaysPerVolunteer !== ""
      ?  Number(task.maxSessionDaysPerVolunteer)
      : null;
      if (this.task.id) {
        await tasksRepo.updateTask(task);
      } else {
        await tasksRepo.createTask(task);
      }
      this.$router.push({
        path: "/volunteers/tasks/",
      });
    },
    deleteSession(session) {
      const index = this.sessions.findIndex(
        element => element === session
      );
      if (index !== -1) {
        this.sessions.splice(index, 1);
        this.task.sessions = this.sessions;
      }
      else {
        return;
      }
    },
    editSession(session) {
      if (this.selectedSessionIndex !== null) {
        this.sessions.splice(this.selectedSessionIndex, 0, this.selectedSession);
      }
      const realIndex = this.sessions.findIndex(
        element => element === session
      );
      if (realIndex === -1) {
        return;
      }
      else {
        this.selectedSessionIndex = realIndex;
        this.selectedSession = { ...session };
        this.sessions.splice(realIndex, 1);
        this.task.sessions = this.sessions;
      }
      this.isEdit = true;
    },
    onAddSession(session) {
      this.sessions.push(session);
      this.task.sessions = this.sessions;
      this.selectedSession = {};
      this.selectedSessionIndex = null;
    },
    openRepeatSession(session) {
      this.sessionToRepeat = { ...session };
      this.repeatFromDate = null;
      this.repeatToDate = null;
      this.openRepeatDialog = true;
    },
    onAddRepeatedSessions(sessions) {
      this.sessions.push(...sessions);
      this.task.sessions = this.sessions;
      this.selectedSession = {};
      this.selectedSessionIndex = null;
    },
  },
  async created() {
    const taskId = this.$route.params.id;
    if (!taskId) return;
    const task = await tasksRepo.getTask(taskId);
    if (this.isDuplicate) {
      // تكرار الفرصة: تعبئة النموذج ببيانات الفرصة الأصلية دون ربطها بها
      this.task = TaskDuplicate(task);
      this.sessions = this.task.sessions;
    } else {
      this.task = Task(task);
      this.sessions = this.task.taskSessions || [];
    }
  },
  mounted() {
    this.getAllCoupons();
    this.getAllVolunteeringFields();
  },
};
</script>

<style scoped>
.session-form {
  gap: 1rem;
  display: flex;
}
</style>